module.exports = __webpack_public_path__ + "static/media/intro.f135a42d.mp3";